exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".controls[data-v-1f4e8940]{margin-top:1em}.controls>div[data-v-1f4e8940]{padding-top:1em}label[data-v-1f4e8940]{display:block;line-height:1.6em}.columns[data-v-1f4e8940]{display:flex;justify-content:stretch}.column[data-v-1f4e8940]{margin-right:20px;flex:1;display:flex;flex-direction:column;flex-grow:1}.column .smooth-dnd-container.vertical[data-v-1f4e8940]{display:flex;flex-direction:column;flex-grow:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f4e8940","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/events.vue
// module id = 60
// module chunks = 0